var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_10695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2327 0H6.76727C3.03574 0 0 3.03574 0 6.76727V18.2329C0 21.9642 3.03574 25 6.76727 25H18.2329C21.9642 25 25 21.9642 25 18.2329V6.76727C25 3.03574 21.9642 0 18.2327 0ZM23.5343 18.2329C23.5343 21.1561 21.1561 23.5343 18.2327 23.5343H6.76727C3.84389 23.5343 1.46562 21.1561 1.46562 18.2329V6.76727C1.46562 3.84389 3.84389 1.46562 6.76727 1.46562H18.2329C21.1561 1.46562 23.5343 3.84389 23.5343 6.76727V18.2329Z",
    fill: "#AE8FD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 5.66401C8.73052 5.66401 5.66406 8.73042 5.66406 12.4998C5.66406 16.2691 8.73047 19.3355 12.4998 19.3355C16.2691 19.3355 19.3355 16.2691 19.3355 12.4998C19.3355 8.73042 16.2691 5.66401 12.4998 5.66401ZM12.4998 17.8699C9.53887 17.8699 7.12969 15.4609 7.12969 12.4998C7.12969 9.53882 9.53887 7.12964 12.4998 7.12964C15.461 7.12964 17.8699 9.53882 17.8699 12.4998C17.8699 15.4609 15.461 17.8699 12.4998 17.8699ZM19.499 3.23633C18.3851 3.23633 17.4791 4.14253 17.4791 5.2562C17.4791 6.37012 18.3851 7.27627 19.499 7.27627C20.6129 7.27627 21.519 6.37012 21.519 5.25625C21.519 4.14238 20.6129 3.23633 19.499 3.23633ZM19.499 5.8105C19.1935 5.8105 18.9447 5.56177 18.9447 5.2562C18.9447 4.95049 19.1935 4.70195 19.499 4.70195C19.8047 4.70195 20.0535 4.95049 20.0535 5.2562C20.0535 5.56177 19.8047 5.8105 19.499 5.8105Z",
    fill: "#AE8FD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_10695"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaHome);
export default __webpack_public_path__ + "static/media/Insta-home.74c8e012b1f18e5668318d43903c4587.svg";
export { ForwardRef as ReactComponent };